import { BusinessTargetConfig, LocaleConfig } from '@shopee-user/global';
import { config } from '@shopee-user/platform';
import { getCookie, createCookie } from '@shopee/cookie';
import { generateRandomString } from './utils';

const { BUSINESS_TARGET, ENV, LOCALE } = config;
const { getApiDomain } = BusinessTargetConfig[BUSINESS_TARGET];

const CSRF_TOKEN_KEY = 'csrftoken';
const SHOPEE_MAIN_DOMAIN_REGEX = /^(test|uat|staging)?\.shopee\.(co\.id|com\.my|com\.sg|com\.vn|com\.tw|com\.ph|com\.br|com\.mx|com\.co|com\.ar|com\.cl)/;
const CSRF_RANDOM_STRING_LENGTH = 32;

/**
 * Get or create a CSRF token cookie.
 * @param cookiePrefix - The prefix to use for the cookie key.
 * * BE will consider 2 cookie keys as valid:
 * * * csrftoken
 * * * root_csrftoken -- generally only set on root domain
 * @returns The CSRF token cookie.
 * BE Reference: https://confluence.shopee.io/x/okYRCw
 */
export function getOrCreateCsrfTokenCookie({
  cookiePrefix,
}: {
  cookiePrefix: string;
}) {
  const cookieKey = `${cookiePrefix}${CSRF_TOKEN_KEY}`;
  let cookie = getCookie(cookieKey);
  const apiDomain = getApiDomain(ENV, LOCALE);
  let hostDomain = undefined;

  if (!cookie) {
    cookie = generateRandomString({ length: CSRF_RANDOM_STRING_LENGTH });

    // check if API domain is using shopee main domain
    if (apiDomain.match(SHOPEE_MAIN_DOMAIN_REGEX)) {
      hostDomain = `.shopee.${LocaleConfig[LOCALE].domain}`;
    }
    createCookie(cookieKey, cookie, 0, hostDomain);
  }
  return cookie;
}
